import { Box, Divider, Group, Paper, Text, ThemeIcon } from '@mantine/core';

import type { Icon } from '@phosphor-icons/react';

type IconDataRow = {
  icon: Icon;
  label: string;
  value: React.ReactNode;
};

export function IconDataTable({ rows }: { rows: IconDataRow[] }) {
  return (
    <Paper withBorder radius="md">
      {rows.map((row, index) => {
        const RowIcon = row.icon;

        return (
          <Box key={row.label}>
            <Group px="md" py="sm" gap="md" wrap="nowrap" align="center">
              <ThemeIcon variant="transparent" color="gray" size="sm">
                <RowIcon size={18} weight="duotone" />
              </ThemeIcon>

              <Text
                c="dimmed"
                size="sm"
                w={150}
                style={{
                  overflowWrap: 'anywhere',
                }}
              >
                {row.label}
              </Text>

              <Box flex={1} miw={0}>
                {typeof row.value === 'string' ? (
                  <Text
                    size="sm"
                    style={{
                      overflowWrap: 'anywhere',
                      whiteSpace: 'normal',
                    }}
                  >
                    {row.value}
                  </Text>
                ) : (
                  row.value
                )}
              </Box>
            </Group>

            {index < rows.length - 1 && <Divider />}
          </Box>
        );
      })}
    </Paper>
  );
}
